import { type AxiosResponse } from 'axios'

import { useMutation } from '@percent/utility'
import { type AssignedDomain, tenantDomains } from '@percent/domain/iam'

type AssignApi = (_: {
  memberId: string
  role: string
  domainId: string
}) => Promise<AxiosResponse<{ data: AssignedDomain; object: string }>>

// `onChange` runs after every change, for data a role change can make stale
// beyond the domain it was made in (the effective roles behind the markers).
export function usePermissionMutations(
  assignApi: AssignApi,
  unassignApi: AssignApi,
  refetch: () => void,
  onChange?: () => void
) {
  const [, { mutateAsync: assignRoleMutation }] = useMutation(assignApi, ({ data }) => {
    if (tenantDomains.includes(data.id)) refetch()
    onChange?.()
  })

  const [, { mutateAsync: unassignRoleMutation }] = useMutation(unassignApi, ({ data }) => {
    if (tenantDomains.includes(data.id)) refetch()
    onChange?.()
  })

  const assignRole = async (params: { memberId: string; role: string; domainId: string }) => {
    const result = await assignRoleMutation(params)

    return result.data
  }

  const unassignRole = async (params: { memberId: string; role: string; domainId: string }) => {
    const result = await unassignRoleMutation(params)

    return result.data
  }

  return { assignRole, unassignRole }
}
